/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseBaseInfo } from './ResponseBaseInfo';
import {
    ResponseBaseInfoFromJSON,
    ResponseBaseInfoFromJSONTyped,
    ResponseBaseInfoToJSON,
    ResponseBaseInfoToJSONTyped,
} from './ResponseBaseInfo';

/**
 * 
 * @export
 * @interface ResponseGetUserListResonse
 */
export interface ResponseGetUserListResonse {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    approval?: boolean;
    /**
     * 
     * @type {Array<ResponseBaseInfo>}
     * @memberof ResponseGetUserListResonse
     */
    baseInfo?: Array<ResponseBaseInfo>;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetUserListResonse
     */
    chatworkRoomId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    driverName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    firstName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetUserListResonse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    introducer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeFsz1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeHnd2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeHnd3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeHnd6?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeHnd9?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeHsg1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeKix1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeKix2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeKix3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeKix4?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeKix5?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeKix6?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeNgo2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeNrt1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeNrt2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeNrt5?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeQcb1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeQcb3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeQcb4?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeQcb5?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpb1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpb2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpb3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpb5?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpb9?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpfA?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpfB?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpfC?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpfD?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpfI?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpf2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpf3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpf4?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpf6?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpf9?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpn1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpn2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpn3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpr1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpx1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpx2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpy1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpy2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpy3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpy5?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz3?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz4?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz5?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz6?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz7?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz8?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTpz9?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo4?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo6?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo7?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo8?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeTyo9?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjgT?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjnA?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjnB?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjnC?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjnD?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjnE?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjwA?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeVjwB?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeWarehouse?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeXje1?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetUserListResonse
     */
    isHopeXje2?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    mail?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetUserListResonse
     */
    permissionId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    sellerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetUserListResonse
     */
    shopName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetUserListResonse
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetUserListResonse
     */
    userNumber?: number;
}

/**
 * Check if a given object implements the ResponseGetUserListResonse interface.
 */
export function instanceOfResponseGetUserListResonse(value: object): value is ResponseGetUserListResonse {
    return true;
}

export function ResponseGetUserListResonseFromJSON(json: any): ResponseGetUserListResonse {
    return ResponseGetUserListResonseFromJSONTyped(json, false);
}

export function ResponseGetUserListResonseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetUserListResonse {
    if (json == null) {
        return json;
    }
    return {
        
        'approval': json['approval'] == null ? undefined : json['approval'],
        'baseInfo': json['base_info'] == null ? undefined : ((json['base_info'] as Array<any>).map(ResponseBaseInfoFromJSON)),
        'chatworkRoomId': json['chatwork_room_id'] == null ? undefined : json['chatwork_room_id'],
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'id': json['id'] == null ? undefined : json['id'],
        'introducer': json['introducer'] == null ? undefined : json['introducer'],
        'isHopeFsz1': json['is_hope_fsz1'] == null ? undefined : json['is_hope_fsz1'],
        'isHopeHnd2': json['is_hope_hnd2'] == null ? undefined : json['is_hope_hnd2'],
        'isHopeHnd3': json['is_hope_hnd3'] == null ? undefined : json['is_hope_hnd3'],
        'isHopeHnd6': json['is_hope_hnd6'] == null ? undefined : json['is_hope_hnd6'],
        'isHopeHnd9': json['is_hope_hnd9'] == null ? undefined : json['is_hope_hnd9'],
        'isHopeHsg1': json['is_hope_hsg1'] == null ? undefined : json['is_hope_hsg1'],
        'isHopeKix1': json['is_hope_kix1'] == null ? undefined : json['is_hope_kix1'],
        'isHopeKix2': json['is_hope_kix2'] == null ? undefined : json['is_hope_kix2'],
        'isHopeKix3': json['is_hope_kix3'] == null ? undefined : json['is_hope_kix3'],
        'isHopeKix4': json['is_hope_kix4'] == null ? undefined : json['is_hope_kix4'],
        'isHopeKix5': json['is_hope_kix5'] == null ? undefined : json['is_hope_kix5'],
        'isHopeKix6': json['is_hope_kix6'] == null ? undefined : json['is_hope_kix6'],
        'isHopeNgo2': json['is_hope_ngo2'] == null ? undefined : json['is_hope_ngo2'],
        'isHopeNrt1': json['is_hope_nrt1'] == null ? undefined : json['is_hope_nrt1'],
        'isHopeNrt2': json['is_hope_nrt2'] == null ? undefined : json['is_hope_nrt2'],
        'isHopeNrt5': json['is_hope_nrt5'] == null ? undefined : json['is_hope_nrt5'],
        'isHopeQcb1': json['is_hope_qcb1'] == null ? undefined : json['is_hope_qcb1'],
        'isHopeQcb3': json['is_hope_qcb3'] == null ? undefined : json['is_hope_qcb3'],
        'isHopeQcb4': json['is_hope_qcb4'] == null ? undefined : json['is_hope_qcb4'],
        'isHopeQcb5': json['is_hope_qcb5'] == null ? undefined : json['is_hope_qcb5'],
        'isHopeTpb1': json['is_hope_tpb1'] == null ? undefined : json['is_hope_tpb1'],
        'isHopeTpb2': json['is_hope_tpb2'] == null ? undefined : json['is_hope_tpb2'],
        'isHopeTpb3': json['is_hope_tpb3'] == null ? undefined : json['is_hope_tpb3'],
        'isHopeTpb5': json['is_hope_tpb5'] == null ? undefined : json['is_hope_tpb5'],
        'isHopeTpb9': json['is_hope_tpb9'] == null ? undefined : json['is_hope_tpb9'],
        'isHopeTpfA': json['is_hope_tpf_a'] == null ? undefined : json['is_hope_tpf_a'],
        'isHopeTpfB': json['is_hope_tpf_b'] == null ? undefined : json['is_hope_tpf_b'],
        'isHopeTpfC': json['is_hope_tpf_c'] == null ? undefined : json['is_hope_tpf_c'],
        'isHopeTpfD': json['is_hope_tpf_d'] == null ? undefined : json['is_hope_tpf_d'],
        'isHopeTpfI': json['is_hope_tpf_i'] == null ? undefined : json['is_hope_tpf_i'],
        'isHopeTpf2': json['is_hope_tpf2'] == null ? undefined : json['is_hope_tpf2'],
        'isHopeTpf3': json['is_hope_tpf3'] == null ? undefined : json['is_hope_tpf3'],
        'isHopeTpf4': json['is_hope_tpf4'] == null ? undefined : json['is_hope_tpf4'],
        'isHopeTpf6': json['is_hope_tpf6'] == null ? undefined : json['is_hope_tpf6'],
        'isHopeTpf9': json['is_hope_tpf9'] == null ? undefined : json['is_hope_tpf9'],
        'isHopeTpn1': json['is_hope_tpn1'] == null ? undefined : json['is_hope_tpn1'],
        'isHopeTpn2': json['is_hope_tpn2'] == null ? undefined : json['is_hope_tpn2'],
        'isHopeTpn3': json['is_hope_tpn3'] == null ? undefined : json['is_hope_tpn3'],
        'isHopeTpr1': json['is_hope_tpr1'] == null ? undefined : json['is_hope_tpr1'],
        'isHopeTpx1': json['is_hope_tpx1'] == null ? undefined : json['is_hope_tpx1'],
        'isHopeTpx2': json['is_hope_tpx2'] == null ? undefined : json['is_hope_tpx2'],
        'isHopeTpy1': json['is_hope_tpy1'] == null ? undefined : json['is_hope_tpy1'],
        'isHopeTpy2': json['is_hope_tpy2'] == null ? undefined : json['is_hope_tpy2'],
        'isHopeTpy3': json['is_hope_tpy3'] == null ? undefined : json['is_hope_tpy3'],
        'isHopeTpy5': json['is_hope_tpy5'] == null ? undefined : json['is_hope_tpy5'],
        'isHopeTpz1': json['is_hope_tpz1'] == null ? undefined : json['is_hope_tpz1'],
        'isHopeTpz2': json['is_hope_tpz2'] == null ? undefined : json['is_hope_tpz2'],
        'isHopeTpz3': json['is_hope_tpz3'] == null ? undefined : json['is_hope_tpz3'],
        'isHopeTpz4': json['is_hope_tpz4'] == null ? undefined : json['is_hope_tpz4'],
        'isHopeTpz5': json['is_hope_tpz5'] == null ? undefined : json['is_hope_tpz5'],
        'isHopeTpz6': json['is_hope_tpz6'] == null ? undefined : json['is_hope_tpz6'],
        'isHopeTpz7': json['is_hope_tpz7'] == null ? undefined : json['is_hope_tpz7'],
        'isHopeTpz8': json['is_hope_tpz8'] == null ? undefined : json['is_hope_tpz8'],
        'isHopeTpz9': json['is_hope_tpz9'] == null ? undefined : json['is_hope_tpz9'],
        'isHopeTyo1': json['is_hope_tyo1'] == null ? undefined : json['is_hope_tyo1'],
        'isHopeTyo2': json['is_hope_tyo2'] == null ? undefined : json['is_hope_tyo2'],
        'isHopeTyo4': json['is_hope_tyo4'] == null ? undefined : json['is_hope_tyo4'],
        'isHopeTyo6': json['is_hope_tyo6'] == null ? undefined : json['is_hope_tyo6'],
        'isHopeTyo7': json['is_hope_tyo7'] == null ? undefined : json['is_hope_tyo7'],
        'isHopeTyo8': json['is_hope_tyo8'] == null ? undefined : json['is_hope_tyo8'],
        'isHopeTyo9': json['is_hope_tyo9'] == null ? undefined : json['is_hope_tyo9'],
        'isHopeVjgT': json['is_hope_vjg_t'] == null ? undefined : json['is_hope_vjg_t'],
        'isHopeVjnA': json['is_hope_vjn_a'] == null ? undefined : json['is_hope_vjn_a'],
        'isHopeVjnB': json['is_hope_vjn_b'] == null ? undefined : json['is_hope_vjn_b'],
        'isHopeVjnC': json['is_hope_vjn_c'] == null ? undefined : json['is_hope_vjn_c'],
        'isHopeVjnD': json['is_hope_vjn_d'] == null ? undefined : json['is_hope_vjn_d'],
        'isHopeVjnE': json['is_hope_vjn_e'] == null ? undefined : json['is_hope_vjn_e'],
        'isHopeVjwA': json['is_hope_vjw_a'] == null ? undefined : json['is_hope_vjw_a'],
        'isHopeVjwB': json['is_hope_vjw_b'] == null ? undefined : json['is_hope_vjw_b'],
        'isHopeWarehouse': json['is_hope_warehouse'] == null ? undefined : json['is_hope_warehouse'],
        'isHopeXje1': json['is_hope_xje1'] == null ? undefined : json['is_hope_xje1'],
        'isHopeXje2': json['is_hope_xje2'] == null ? undefined : json['is_hope_xje2'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'permissionId': json['permission_id'] == null ? undefined : json['permission_id'],
        'sellerId': json['seller_id'] == null ? undefined : json['seller_id'],
        'shopName': json['shop_name'] == null ? undefined : json['shop_name'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userNumber': json['user_number'] == null ? undefined : json['user_number'],
    };
}

export function ResponseGetUserListResonseToJSON(json: any): ResponseGetUserListResonse {
    return ResponseGetUserListResonseToJSONTyped(json, false);
}

export function ResponseGetUserListResonseToJSONTyped(value?: ResponseGetUserListResonse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval': value['approval'],
        'base_info': value['baseInfo'] == null ? undefined : ((value['baseInfo'] as Array<any>).map(ResponseBaseInfoToJSON)),
        'chatwork_room_id': value['chatworkRoomId'],
        'driver_name': value['driverName'],
        'first_name': value['firstName'],
        'id': value['id'],
        'introducer': value['introducer'],
        'is_hope_fsz1': value['isHopeFsz1'],
        'is_hope_hnd2': value['isHopeHnd2'],
        'is_hope_hnd3': value['isHopeHnd3'],
        'is_hope_hnd6': value['isHopeHnd6'],
        'is_hope_hnd9': value['isHopeHnd9'],
        'is_hope_hsg1': value['isHopeHsg1'],
        'is_hope_kix1': value['isHopeKix1'],
        'is_hope_kix2': value['isHopeKix2'],
        'is_hope_kix3': value['isHopeKix3'],
        'is_hope_kix4': value['isHopeKix4'],
        'is_hope_kix5': value['isHopeKix5'],
        'is_hope_kix6': value['isHopeKix6'],
        'is_hope_ngo2': value['isHopeNgo2'],
        'is_hope_nrt1': value['isHopeNrt1'],
        'is_hope_nrt2': value['isHopeNrt2'],
        'is_hope_nrt5': value['isHopeNrt5'],
        'is_hope_qcb1': value['isHopeQcb1'],
        'is_hope_qcb3': value['isHopeQcb3'],
        'is_hope_qcb4': value['isHopeQcb4'],
        'is_hope_qcb5': value['isHopeQcb5'],
        'is_hope_tpb1': value['isHopeTpb1'],
        'is_hope_tpb2': value['isHopeTpb2'],
        'is_hope_tpb3': value['isHopeTpb3'],
        'is_hope_tpb5': value['isHopeTpb5'],
        'is_hope_tpb9': value['isHopeTpb9'],
        'is_hope_tpf_a': value['isHopeTpfA'],
        'is_hope_tpf_b': value['isHopeTpfB'],
        'is_hope_tpf_c': value['isHopeTpfC'],
        'is_hope_tpf_d': value['isHopeTpfD'],
        'is_hope_tpf_i': value['isHopeTpfI'],
        'is_hope_tpf2': value['isHopeTpf2'],
        'is_hope_tpf3': value['isHopeTpf3'],
        'is_hope_tpf4': value['isHopeTpf4'],
        'is_hope_tpf6': value['isHopeTpf6'],
        'is_hope_tpf9': value['isHopeTpf9'],
        'is_hope_tpn1': value['isHopeTpn1'],
        'is_hope_tpn2': value['isHopeTpn2'],
        'is_hope_tpn3': value['isHopeTpn3'],
        'is_hope_tpr1': value['isHopeTpr1'],
        'is_hope_tpx1': value['isHopeTpx1'],
        'is_hope_tpx2': value['isHopeTpx2'],
        'is_hope_tpy1': value['isHopeTpy1'],
        'is_hope_tpy2': value['isHopeTpy2'],
        'is_hope_tpy3': value['isHopeTpy3'],
        'is_hope_tpy5': value['isHopeTpy5'],
        'is_hope_tpz1': value['isHopeTpz1'],
        'is_hope_tpz2': value['isHopeTpz2'],
        'is_hope_tpz3': value['isHopeTpz3'],
        'is_hope_tpz4': value['isHopeTpz4'],
        'is_hope_tpz5': value['isHopeTpz5'],
        'is_hope_tpz6': value['isHopeTpz6'],
        'is_hope_tpz7': value['isHopeTpz7'],
        'is_hope_tpz8': value['isHopeTpz8'],
        'is_hope_tpz9': value['isHopeTpz9'],
        'is_hope_tyo1': value['isHopeTyo1'],
        'is_hope_tyo2': value['isHopeTyo2'],
        'is_hope_tyo4': value['isHopeTyo4'],
        'is_hope_tyo6': value['isHopeTyo6'],
        'is_hope_tyo7': value['isHopeTyo7'],
        'is_hope_tyo8': value['isHopeTyo8'],
        'is_hope_tyo9': value['isHopeTyo9'],
        'is_hope_vjg_t': value['isHopeVjgT'],
        'is_hope_vjn_a': value['isHopeVjnA'],
        'is_hope_vjn_b': value['isHopeVjnB'],
        'is_hope_vjn_c': value['isHopeVjnC'],
        'is_hope_vjn_d': value['isHopeVjnD'],
        'is_hope_vjn_e': value['isHopeVjnE'],
        'is_hope_vjw_a': value['isHopeVjwA'],
        'is_hope_vjw_b': value['isHopeVjwB'],
        'is_hope_warehouse': value['isHopeWarehouse'],
        'is_hope_xje1': value['isHopeXje1'],
        'is_hope_xje2': value['isHopeXje2'],
        'last_name': value['lastName'],
        'mail': value['mail'],
        'permission_id': value['permissionId'],
        'seller_id': value['sellerId'],
        'shop_name': value['shopName'],
        'tenant_id': value['tenantId'],
        'user_number': value['userNumber'],
    };
}

